'use strict';

var base = require('../product/base');

document.addEventListener('vviinnAddToBasket', ({ detail }) => {
	base.addVviinnProductToCart(detail.productId);
});
